<template>
  <main class="platforms-page">
    <AppNavBar :title="t('card.allSupportedPlatforms')" />

    <section class="platforms-card">
      <h2>{{ t("card.recentTradeScene") }}</h2>
      <div class="dash-line" />

      <div
        v-for="(group, groupIndex) in supportSceneGroups"
        :key="group.id || group.label || groupIndex"
        class="platform-group"
      >
        <div v-if="groupIndex > 0" class="dash-line" />
        <div class="platform-group__label">{{ group.label || "" }}</div>
        <div
          v-for="(item, itemIndex) in group.list"
          :key="item.id || item.name || itemIndex"
          class="platform-item"
        >
          <app-image class="platform-item__logo" :src="item.logo" alt="" />
          <span>{{ item.name || "" }}</span>
          <app-image
            class="platform-item__status"
            :src="item.supported === true ? checkYesIcon : checkNoIcon"
            alt=""
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { getRouteState } from "@/utils/route-state";
import checkYesIcon from "@/assets/images/check_yes.png";
import checkNoIcon from "@/assets/images/check_no.png";

const { t } = useI18n();
const route = useRoute();
const pageState = computed(() => getRouteState(route, "card-platforms", {}));
const supportSceneGroups = computed(() =>
  Array.isArray(pageState.value.supportSceneList)
    ? pageState.value.supportSceneList.map((group) => ({
        ...group,
        list: Array.isArray(group?.list) ? group.list : [],
      }))
    : [],
);
</script>

<style scoped lang="scss">
.platforms-page {
  min-height: var(--app-viewport-height);
  padding: 0 14px 24px;
  background: #f7f8fa;
}

.platforms-card {
  padding: 20px 16px;
  border-radius: 16px;
  background: #ffffff;

  h2 {
    margin: 0;
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    padding: 0;
    line-height: 24px;
  }
}

.dash-line {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  border-bottom: 1px dashed #e0e0e0;
}

.platform-group__label {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}

.platform-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;

  > span {
    flex: 1;
    min-width: 0;
    color: #000000;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }
}

.platform-item__logo {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
}

.platform-item__status {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
}
</style>
